import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

import { type SupportRequestWithRelations } from "../supportConstants";
import { SupportRequestCard } from "./SupportRequestCard";

interface DraggableRequestCardProps {
  request: SupportRequestWithRelations;
  hasUnread?: boolean;
  onClick: (request: SupportRequestWithRelations) => void;
}

export const DraggableRequestCard: React.FC<DraggableRequestCardProps> = ({ request, hasUnread, onClick }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: request.id,
    data: { request },
  });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
    touchAction: "none",
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <SupportRequestCard request={request} hasUnread={hasUnread} onClick={() => onClick(request)} />
    </div>
  );
};
